import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { Especialidade } from '../../especialidade/especialidade';
import { EspecialidadeService } from '../../especialidade/especialidade.service';
import { UF } from '../../util/uf';
import { Util } from '../../util/util';
import { Medico } from '../medico';
import { MedicoService } from '../medico.service';
import { ChaveValorNumberInterface } from '../../util/chave-valor-number-interface';

@Component({
  selector: 'app-medico-maintenance',
  templateUrl: './medico-maintenance.component.html',
  styleUrls: ['./medico-maintenance.component.css']
})
export class MedicoMaintenanceComponent implements OnInit {

  id: number;

  isUpdate: string;

  isInfo:boolean = false;

  medico: Medico;

  formularioMedico: FormGroup;

  tituloCrud: string = '';

  public listaUFs: UF[];

  public listaDiasAgenda: ChaveValorNumberInterface[];

  public listaEspecialidades: Especialidade[];

  constructor(private medicoService: MedicoService,
    private especialidadeService: EspecialidadeService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;
    this.isUpdate = history.state.isUpdate;

    this.medico = new Medico();

    this.formularioMedico = this.formBuilder.group({
      id: 0,
      nome: ['', [Validators.required, Validators.minLength(6)]],
      cpf: ['', CpfCnpjValidator.validate],
      logradouro: ['', [Validators.minLength(6)]],
      numero: [''],
      bairro: ['', [Validators.minLength(6)]],
      cidade: ['', [Validators.minLength(6)]],
      complemento: [''],
      estado: [''],
      cep: ['',],
      fone: [''],
      especialidade: ['', [Validators.required]],
      medicoPlanoSaude: [],
      qtdDiasAgenda: ['', [Validators.required]],
    });

    this.listaUFs = Util.listaUFs;

    this.listaDiasAgenda = Util.listaDiasAgenda;

    this.listaEspecialidades = [];
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Médico';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Médico';
      }
    } else {
      this.tituloCrud = 'Criar Médico';
    }

    this.listarEpecialidades();
  }

  save() {

    this.medico = this.formularioMedico.value;

    if (this.isNew()) {
      this.medicoService
        .criar(this.medico).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.medicoService.atualizar(this.medico, this.id)
        .subscribe(data => {
          // console.log(data); 

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/medicos']);
  }

  isNew(): boolean {
    return this.id == null || this.id == 0;
  }

  get formControl() {
    return this.formularioMedico.controls;
  }

  listarEpecialidades() {
    this.especialidadeService.listar()
      .subscribe(data => {
        // console.log(data)
        this.listaEspecialidades = data;

        this.configurarForm();
      }, error => {
        console.log(error);
      });
  }

  configurarForm(): void {
    if (!this.isNew()) {
      this.medicoService.procurarPorId(this.id)
        .subscribe(data => {
          // console.log(data)

          this.medico = data;
          if (!this.medico.cpf) {
            this.medico.cpf = '';
          }

          this.formularioMedico.patchValue(this.medico);

          let currentEspecialidade = this.listaEspecialidades.filter(espec => espec.id == this.medico.especialidade.id)[0];
          this.formularioMedico.controls.especialidade.patchValue(currentEspecialidade);
          this.formularioMedico.controls.cpf.patchValue(cpf.format(this.medico.cpf));

          this.cd.detectChanges();

          if (this.isUpdate == 'N') {
            this.formularioMedico.disable();
          }
        }, error => {
          console.log(error);
        });
    } else {
      this.formularioMedico.setValue({
        id: 0,
        nome: '',
        cpf: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        complemento: '',
        estado: '',
        cep: '',
        fone: '',
        especialidade: '',
        qtdDiasAgenda: '',
        medicoPlanoSaude: []
      });
    }
  }
}
